import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/customer-group/$id')({
    beforeLoad: ({ params }) => {
        // Redirect to new pluralized route
        throw redirect({
            to: '/customer-groups/$groupId',
            params: { groupId: params.id },
        });
    },
});
